import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
  AbstractControl,
  ValidationErrors,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subscription } from 'rxjs';
import {
  DateFormats,
  DistributorList,
  ModalID,
  StatusModalIndicator,
} from 'src/app/shared/models/constants';
import {
  DistributorConfig,
  DistributorInventoryProfile,
} from 'src/app/shared/models/general';
import { SharedService } from 'src/app/shared/services/shared.service';
import { format } from 'date-fns';
import * as cryptoJS from 'crypto-js'; // Import the entire library
import { DistributorService } from 'src/app/shared/services/distributor.service';

@Component({
  selector: 'app-distributor-management',
  templateUrl: './distributor-management.component.html',
  styleUrls: ['./distributor-management.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, DatePipe, NgSelectModule],
})
export class DistributorManagementComponent implements OnInit {
  subscriptions = new Subscription();
  distributor_config_form: FormGroup;
  distributor_list: DistributorProfile[] = [];
  distributor_api_list: DistributorProfile[] = [];
  distributor_inventory_list: DistributorProfile[] = [];
  selected_distributor: string;
  selected_distributor_list: DistributorConfig[] = [];
  selected_distributor_inventory: DistributorInventoryProfile[] = [];
  selected_management_option: string;
  management_options = ['Distributor Credentials', 'Live Inventory Accounts'];
  selected_inventory_distributor: {
    name: string;
    value: string;
    api: boolean;
    inventory: boolean;
  }[] = [];
  constructor(
    public sharedService: SharedService,
    public distributorService: DistributorService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {
    this.distributor_config_form = this.fb.group({
      configs: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.distributor_list = DistributorList;
    this.distributor_list = [
      ...this.distributor_list.sort((a, b) => a.value.localeCompare(b.value)),
    ];
    this.distributor_api_list = this.distributor_list.filter((x) => x.api);
    this.distributor_inventory_list = this.distributor_list.filter(
      (x) => x.inventory,
    );
    this.getAllDistributorConfigs();
    this.getAllInventoryDistributors();
  }
  async getAllDistributorConfigs() {
    await this.distributorService.getAllDistributorConfigs().then((res) => {
      if (res) {
        if (res.length > 0) {
          const distributor_configs = res;
          distributor_configs.forEach((config) => {
            this.addNewConfig(config);
            this.selected_distributor_list.push(config);
            const selectedDistributor = this.distributor_api_list.find(
              (x) => x.value === config.distributor_name,
            );
            if (selectedDistributor) {
              this.distributor_api_list = this.distributor_api_list.filter(
                (x) => x.value !== selectedDistributor.value,
              );
            }
          });
        }
      }
    });
  }
  get configs(): FormArray {
    const control = this.distributor_config_form.get('configs');
    return control instanceof FormArray ? control : this.fb.array([]);
  }
  addNewConfig(config: DistributorConfig): void {
    this.configs.push(this.createItem(config));
  }
  createItem(config: DistributorConfig): FormGroup {
    return this.fb.group({
      distributor_name: [
        { value: config.distributor_name, disabled: true },
        Validators.required,
      ],
      username: [
        { value: config.username, disabled: false },
        this.requiredIfNotNull(),
      ],
      password: [
        { value: config.password, disabled: false },
        this.requiredIfNotNull(),
      ],
      sid: [{ value: config.sid, disabled: false }, this.requiredIfNotNull()],
      token: [
        { value: config.token, disabled: false },
        this.requiredIfNotNull(),
      ],
    });
  }
  onManagementOptionChange(option: string | null): void {
    this.selected_management_option = option?.trim() || null;
    this.selected_distributor = null;
  }

  onDistributorChange(distributorName: string | null): void {
    this.selected_distributor = distributorName || null;
  }
  AddDistributorClick() {
    if (!this.selected_distributor) return;

    let distributor_config = new DistributorConfig();
    const selectedDistributor = this.distributor_list.find(
      (x) => x.name === this.selected_distributor,
    );

    if (!selectedDistributor) {
      console.error('Selected distributor not found in the list');
      return;
    }
    if (selectedDistributor.name === 'cssi') {
      distributor_config.distributor_name = selectedDistributor.value;
      ((distributor_config.sid = ''),
        (distributor_config.token = ''),
        (distributor_config.username = null),
        (distributor_config.password = null));
    } else if (selectedDistributor.name === 'davidsons') {
      distributor_config.distributor_name = selectedDistributor.value;
      ((distributor_config.sid = null),
        (distributor_config.token = null),
        (distributor_config.username = ''),
        (distributor_config.password = ''));
    } else if (selectedDistributor.name === 'zanders') {
      distributor_config.distributor_name = selectedDistributor.value;
      ((distributor_config.sid = null),
        (distributor_config.token = null),
        (distributor_config.username = ''),
        (distributor_config.password = ''));
    } else if (selectedDistributor.name === 'lipseys') {
      distributor_config.distributor_name = selectedDistributor.value;
      ((distributor_config.sid = null),
        (distributor_config.token = null),
        (distributor_config.username = ''),
        (distributor_config.password = ''));
    } else if (selectedDistributor.name === 'rsr_group') {
      distributor_config.distributor_name = selectedDistributor.value;
      ((distributor_config.sid = null),
        (distributor_config.token = null),
        (distributor_config.username = ''),
        (distributor_config.password = ''));
    }
    // Remove the selected distributor from the list
    this.distributor_api_list = this.distributor_api_list.filter(
      (x) => x.name !== this.selected_distributor,
    );
    this.distributor_api_list = [
      ...this.distributor_api_list.sort((a, b) =>
        a.value.localeCompare(b.value),
      ),
    ];
    this.addNewConfig(distributor_config);
    this.selected_distributor_list.push(distributor_config);
    this.selected_distributor = null; // Reset the selected distributor
  }
  async saveDistributionConfig(index: number) {
    this.sharedService.openStatusSpinner('Saving distributor config');
    try {
      const form_config =
        this.distributor_config_form.getRawValue().configs[index];
      const distributor_config = new DistributorConfig();
      distributor_config.distributor_name = form_config.distributor_name;
      distributor_config.sid = form_config.sid;
      distributor_config.token = form_config.token;
      distributor_config.username = form_config.username;
      distributor_config.password = form_config.password;
      distributor_config.updated_datetime = format(
        new Date(),
        DateFormats.M_D_Y_H_M_S,
      );
      distributor_config.updated_by = 'bdpatterson'; //this.sharedService.logged_in_user.username;
      distributor_config.input_hash = await cryptoJS
        .MD5(distributor_config)
        .toString();
      if (!this.selected_distributor_list[index]._id) {
        const res =
          await this.distributorService.saveDistributorConfig(
            distributor_config,
          );
      } else if (
        distributor_config.input_hash !==
        this.selected_distributor_list[index].input_hash
      ) {
        const res = await this.distributorService.updateDistributorConfig(
          this.selected_distributor_list[index]._id,
          distributor_config,
        );
      }
      this.sharedService.closeStatusSpinner();
      this.sharedService.raiseSuccessToast(
        'Distributor config saved successfully',
      );
    } catch (error) {
      this.sharedService.closeStatusSpinner();
      this.sharedService.openMessageModal(error.message);
      console.error('Error saving distribution config:', error);
      // Handle error as needed
    }
  }
  async removeDistributor(index: number) {
    try {
      // Validate index to prevent out-of-bounds errors
      if (index < 0 || index >= this.selected_distributor_list.length) {
        throw new Error('Invalid distributor index');
      }
      const deletedDistributor = this.selected_distributor_list[index];
      const deletedDistributorName = deletedDistributor.distributor_name;
      const distributorId = deletedDistributor._id;

      if (this.selected_distributor_list[index]?._id) {
        // Call the delete service method
        const res =
          await this.distributorService.deleteDistributorConfig(distributorId);

        // Check if the response indicates success (adjust based on your service's response)
        if (!res) {
          throw new Error('Delete operation returned no response');
        }

        // Success handling
        this.sharedService.raiseSuccessToast(
          'Distributor config deleted successfully',
        );
      } else {
        // Find the deleted distributor in the master list
        const deletedDistributorItem = DistributorList.filter(
          (x) => x.value === deletedDistributorName,
        )[0];

        if (deletedDistributorItem) {
          // Add back to the distributor list and sort
          this.distributor_api_list.push(deletedDistributorItem);
          this.distributor_api_list = [
            ...this.distributor_api_list.sort((a, b) =>
              a.value.localeCompare(b.value),
            ),
          ];
        } else {
          console.warn(
            `Distributor ${deletedDistributorName} not found in DistributorList`,
          );
        }
      }
      // Remove from selected list and form array
      this.selected_distributor_list.splice(index, 1);
      this.configs.removeAt(index);
    } catch (error) {
      // Error handling
      console.error('Error removing distributor:', error.message);
      this.sharedService.openMessageModal(
        `Failed to delete distributor: ${error.message}`,
      );
    }
  }
  requiredIfNotNull(): (control: AbstractControl) => ValidationErrors | null {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value !== null) {
        return Validators.required(control);
      }
      return null;
    };
  }

  async selectInventoryDistributor(event: Event, index: number) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked; 
    const distName = this.distributor_inventory_list[index].name;
    
    // Ensure the array exists
    let selected_list = this.sharedService.company_info.live_inv_selected_distributors || [];
    
    // Clean up any historical duplicates for this distributor
    selected_list = selected_list.filter(dist => dist.name !== distName);
    
    // Add the single authoritative entry for this distributor
    const updatedAt = format(
      new Date(),
      DateFormats.M_D_Y_H_M_S,
    );
    const updatedBy = 'bdpatterson'; //this.sharedService.logged_in_user.username;
    
    selected_list.push({ 
      name: distName, 
      selected: isChecked,
      updated_datetime: updatedAt,
      updated_by: updatedBy
    });

    // Deduplicate the entire array by name just in case there are other duplicates
    const uniqueList: DistributorInventoryProfile[] = [];
    const seenNames = new Set<string>();
    
    // Process backwards to keep the most recently added items (our explicit push above)
    for (let i = selected_list.length - 1; i >= 0; i--) {
        const item = selected_list[i];
        if (!seenNames.has(item.name)) {
            seenNames.add(item.name);
            uniqueList.unshift(item); // Add to front so order is preserved
        }
    }

    this.sharedService.company_info.live_inv_selected_distributors = uniqueList;
    this.distributorService.live_inv_selected_distributors = uniqueList;

    // Send the update to the backend
    try {
      await this.distributorService.updateLiveInventoryDistributorList();
      this.sharedService.raiseSuccessToast('Selections were successfully updated!');
    } catch (err) {
      console.error('Failed to update live inventory distributors:', err);
    }
  }

  async getAllInventoryDistributors() {
    // We rely on sharedService.company_info, but call the service to sync if needed
    await this.distributorService.getLiveInventoryDistributorList();
  }

  isDistributorSelected(name: string): boolean {
    const list = this.sharedService.company_info?.live_inv_selected_distributors || [];
    return list.some((distributor) => distributor.name === name && distributor.selected === true);
  }

}

class DistributorProfile {
  name: string;
  value: string;
  api: boolean;
  inventory: boolean;
}

// class DistributorInventoryProfile {
//   name: string;
//   selected: boolean;
// }
